// Fielding is over across the whole terminal band, not on `finished` alone — a refunded survey has
// stopped collecting too. Matching the producer here keeps the report from claiming analysis is
// still running, or a share still provisional, while its sibling figures render a completed account.
const FIELDING_COMPLETE_STATUSES = ['finished', 'auto_refund', 'manual_refund']

export const fieldingComplete = surveyStatus => FIELDING_COMPLETE_STATUSES.includes(surveyStatus)
